import React from 'react';
import { TextField } from '@td-client-frontend/common';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  type?: string;
  wrapperClasses?: string;
  toolTip?: string;
  readOnly?: boolean;
  required?: boolean;
  requiredIf?: string[];
}

export const TextFieldRhf = ({ ...props }: Props) => {
  return (
    <ComponentWrapperRHF {...props}>
      <TextField />
    </ComponentWrapperRHF>
  );
};
